import React, { useEffect, useState } from "react";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";
import DataList from "../components/DataList";
import { getActions } from "../actions/actionActions";

const ActionsList = () => {
  const [actions, setActions] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => refreshData(), []);

  const refreshData = async () => {
    try {
      setIsFetching(true);
      const actions = await getActions();
      setActions(actions);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <CenteredPageContentContainer>
      <PaperContainer title="Acties">
        <DataList
          data={actions.map((action) => {
            return {
              id: action.id,
              title: action.title,
              onClick: () => (window.location.href = action.onClick),
            };
          })}
          isFetching={isFetching}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  );
};

export default ActionsList;



// WEBPACK FOOTER //
// ./src/components/ActionsList.js